import _Object$assign from '@babel/runtime-corejs3/core-js-stable/object/assign';
import { c as classNames } from '../../shared/bind-a2a3a613.js';
import { getTestId } from '../../utils/testId.js';
import { jsxs, jsx } from 'react/jsx-runtime';

var styles = {
  "unit-base": "4",
  "label": "web_ui__Label__label",
  "content": "web_ui__Label__content",
  "suffix": "web_ui__Label__suffix",
  "default": "web_ui__Label__default",
  "narrow": "web_ui__Label__narrow",
  "wide": "web_ui__Label__wide",
  "leading": "web_ui__Label__leading",
  "stacked": "web_ui__Label__stacked"
};

var LABEL_TYPE_VALUES = ['stacked', 'leading'];
var LABEL_STYLING_VALUES = ['default', 'narrow', 'wide'];
/* ---------- Back-compat shim (deprecated) ---------- */
var LABEL_TYPE = {
  Stacked: 'stacked',
  Leading: 'leading'
};
var LABEL_STYLING = {
  Default: 'default',
  Narrow: 'narrow',
  Wide: 'wide'
};

/* ---------- Type definitions ---------- */

var cssClasses = classNames.bind(styles);
var LabelBase = function LabelBase(_ref) {
  var text = _ref.text,
    _ref$styling = _ref.styling,
    styling = _ref$styling === void 0 ? 'default' : _ref$styling,
    type = _ref.type,
    suffix = _ref.suffix,
    testId = _ref.testId;
  var labelClass = cssClasses('label', styling, type);
  return /*#__PURE__*/jsxs("div", {
    className: labelClass,
    "data-testid": testId,
    children: [/*#__PURE__*/jsx("div", {
      className: styles.content,
      "data-testid": getTestId(testId, 'text'),
      children: text
    }), suffix ? /*#__PURE__*/jsx("div", {
      className: styles.suffix,
      "data-testid": getTestId(testId, 'suffix'),
      children: suffix
    }) : null]
  });
};

/** The public component type: a React component value that also has deprecated statics */

/** Exported component: arrow fn + statics, deprecations intact, docgen-friendly */
var Label = _Object$assign(LabelBase, {
  /** @deprecated Use string unions, e.g. styling="narrow" */
  Styling: LABEL_STYLING,
  /** @deprecated Use string unions, e.g. type="leading" */
  Type: LABEL_TYPE
});

export { LABEL_STYLING, LABEL_STYLING_VALUES, LABEL_TYPE, LABEL_TYPE_VALUES, Label, Label as default };
//# sourceMappingURL=Label.js.map
